import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import query from 'syf-component-library/const/mediaQueries';
import H5 from 'syf-component-library/ui/typography/H5';
import { colors, fontSizes, spacing } from 'syf-component-library/defaultTheme';
export const ContentContainer = styled(Inset) `
  max-width: 672px;
  margin-inline: auto;
  padding: 0;
  margin: 0 48px;

  @media ${query.lessThanMedium} {
    margin: 0 ${spacing.large}px;
  }
`;
export const MainTitle = styled(H5) `
  padding-bottom: ${spacing.medium}px;
  border-bottom: 1px solid ${colors.lightGrey};

  @media ${query.lessThanMedium} {
    font-size: ${fontSizes.medium}px;
  }
`;
